module.exports = __webpack_public_path__ + "img/map_quartiere_residenziale.b3aa6883.png";